/* b2g-link-vid.js
 * Appends our visitor_id to any LINK that points at the external B2G quote form
 * (b2g-form.agilite-hub.com) — e.g. the buttons on the gov-sales page — so the
 * button-redirect path carries the vid the same way the embedded iframe does
 * (the form reads ?visitorID= and forwards it server-side).
 *
 * SAFE / forward-compatible: this only adds an extra query param to those links.
 * Until the form is wired to read it, the param is simply ignored — nothing
 * about the form's current behaviour changes. No-ops if there's no vid yet.
 */
(function () {
  'use strict';

  var HOST = 'b2g-form.agilite-hub.com';

  function vid() {
    try {
      if (window.SE_visitorIdentity && window.SE_visitorIdentity.visitor_id) {
        return window.SE_visitorIdentity.visitor_id;
      }
    } catch (e) {}
    try { return localStorage.getItem('visitorID') || ''; } catch (e) { return ''; }
  }

  function stamp() {
    var v = vid();
    if (!v) return;
    var links = document.querySelectorAll('a[href*="' + HOST + '"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      if (href.indexOf(HOST) === -1) continue;
      if (href.indexOf('visitorID=') !== -1) continue;        // already stamped
      a.setAttribute('href', href + (href.indexOf('?') !== -1 ? '&' : '?') + 'visitorID=' + encodeURIComponent(v));
    }
  }

  if (document.readyState !== 'loading') stamp();
  else document.addEventListener('DOMContentLoaded', stamp);
  // vid often resolves AFTER load (scarcity engine) -> stamp again when it announces.
  window.addEventListener('SE_visitorIdentified', stamp);
})();
